import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SessionStorageService, MenuService } from '../../services';
import { SubSink } from 'subsink';
import { Tenant } from '../../models';
import { TenantsService } from '../../services/tenants.service';

@Component({
  selector: 'mmg-switch-tenants',
  templateUrl: './switch-tenants.component.html',
  styleUrl: './switch-tenants.component.scss'
})
export class SwitchTenantsComponent implements OnDestroy {

  private readonly subs = new SubSink();

  tenants: Tenant[] = [];
  tenantId: string;

  constructor(
    private readonly dialogRef: MatDialogRef<SwitchTenantsComponent>,
    private readonly tenantsService: TenantsService,
    private readonly sessionStorageService: SessionStorageService,
    private readonly router: Router,
    private readonly menuService: MenuService,
    @Inject(MAT_DIALOG_DATA) private data: { tenants: Tenant[] }
  ) {
    const tenants = [...(this.data?.tenants ?? [])];
    this.tenants = tenants.map(t => ({
      ...t, type: `labels.${t.type.toLowerCase()}`
    }));

    const user = this.sessionStorageService.getUser();
    this.tenantId = user.tenantId!;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  switch(tenantId: string): void {
    this.subs.sink = this.tenantsService
      .post(tenantId)
      .subscribe(response => {
        if (response?.token) {
          this.sessionStorageService.setUser({
            tenantId: response.user.tenantId,
            email: response.user.email,
            language: response.user.language,
            roles: response.user.roles
          }, response.token);

          this.menuService.load();
          this.router.navigate(['dashboard'])
            .then(() => {
              window.location.reload();
            });
          this.dialogRef.close();
        }
      });
  }

}